<template>
  <div v-if="eodReports" id="data-list-list-view" class="data-list-container">
    <vs-table
      ref="table"
      class="mt-8"
      v-model="selected"
      pagination
      max-items="100"
      search
      :data="currentEodReports"
      @selected="onClicked(selected.id)"
    >
      <template slot="thead">
        <vs-th sort-key="date">Date</vs-th>
        <vs-th sort-key="date">Submitted by</vs-th>
        <!--<vs-th sort-key="totalRevenue">Total Revenue</vs-th>-->
        <vs-th sort-key="Status">Status</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <code>
                {{ moment(tr.date).format("LL") }}
              </code>
            </vs-td>

            <vs-td>
              <code>
                {{ tr.submittedAction ? tr.submittedAction.userDisplayName : "N/A" }}
              </code>
            </vs-td>

            <!--<vs-td>
              <p>{{ tr.totalRevenue }} DKK</p>
            </vs-td>-->
            <vs-td>
              <vs-chip style="color: #111" :color="tr.status === 2 ? 'success' : 'danger'">{{
                tr.status === 2 ? "Completed" : "Draft, not sent"
              }}</vs-chip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import moment from "moment";

export default {
  components: {},
  data() {
    return {
      moment,
      query: "*",
      visitToDelete: null,
      selected: [],
      isMounted: false,
    };
  },
  computed: {
    ...mapGetters({
      eodReports: "eodReports/eodReports",
      activeVenue: "venues/activeVenue",
      user: "users/user",
    }),

    currentEodReports: function () {
      console.log("currentEodReports", this.eodReports);
      const res = this.eodReports.filter(e => e.status === 2); // we only want completed EoDs ("SentMail")

      // Sort by submitted date
      res.sort((a, b) => {
        return b.date > a.date ? 1 : -1;
      });

      return res ? res : [];
    },
  },
  methods: {
    async onClickCreateNew() {
      var result = await this.$store.dispatch("eodReports/addNewEodReport", this.activeVenue.venueId);
      this.$router.push({ name: "eodReport", params: { id: result.eodReportId } }).catch(() => {});
    },
    onClicked(id) {
      console.log("Clicked", id);
      this.$router.push({ name: "eodReport", params: { id: id } }).catch(() => {});
    },
  },
  created() {},
  async mounted() {
    this.isMounted = true;

    // TODO load
    await this.$store.dispatch("eodReports/getEodReports", this.activeVenue.venueId);
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>